import { Routes } from '@angular/router';
import { CombinacaoKitsComponent } from '../combinacao-kits/combinacao-kits.component';
import { CadastrarCondicaoDePagamentoComponent } from '../condicao-de-pagamento/cadastrar-condicao-de-pagamento/cadastrar-condicao-de-pagamento.component';
import { CondicaoDePagamentoComponent } from '../condicao-de-pagamento/condicao-de-pagamento.component';
import { EtapaComponent } from '../etapa/etapa.component';
import { CadastrarFormaDePagamentoComponent } from '../forma-de-pagamento/cadastrar-forma-de-pagamento/cadastrar-forma-de-pagamento.component';
import { FormaDePagamentoComponent } from '../forma-de-pagamento/forma-de-pagamento.component';
import { CadastrarFuncionarioComponent } from '../funcionario/cadastrar-funcionario/cadastrar-funcionario.component';
import { FuncionarioComponent } from '../funcionario/funcionario.component';
import { GestaoDeDescontosComponent } from '../gestao-de-descontos/gestao-de-descontos.component';
import { AuthGuard } from '../guards/auth.guard';
import { HierarquiaUsuarioComponent } from '../hierarquia-usuario/hierarquia-usuario.component';
import { CadastrarModeloDeDownloadComponent } from '../modelo-de-download/cadastrar-modelo-de-download/cadastrar-modelo-de-download.component';
import { ModeloDeDownloadComponent } from '../modelo-de-download/modelo-de-download.component';
import { CadastrarMotivoPerdaOrcComponent } from '../motivo-perda-orc/cadastrar-motivo-perda-orc/cadastrar-motivo-perda-orc.component';
import { MotivoPerdaOrcComponent } from '../motivo-perda-orc/motivo-perda-orc.component';
import { CadastrarOrcStatusComponent } from '../orc-status/cadastrar-orc-status/cadastrar-orc-status.component';
import { OrcStatusComponent } from '../orc-status/orc-status.component';
import { PremissasComponent } from '../premissas/premissas.component';
import { CadastrarProdutoComponent } from '../produtos/cadastrar-produto/cadastrar-produto.component';
import { ProdutosComponent } from '../produtos/produtos.component';
import { CadastrarPromocaoComponent } from '../promocao/cadastrar-promocao/cadastrar-promocao.component';
import { PromocaoComponent } from '../promocao/promocao.component';
import { TabelaDeFretesComponent } from '../tabela-de-fretes/tabela-de-fretes.component';
import { CadastrarTagGiComponent } from '../tag-gi/cadastrar-tag-gi/cadastrar-tag-gi.component';
import { TagGiComponent } from '../tag-gi/tag-gi.component';
import { CadastrarTemplateEmailComponent } from '../template-email/cadastrar-template-email/cadastrar-template-email.component';
import { TemplateEmailComponent } from '../template-email/template-email.component';
import { ConfiguracoesComponent } from './configuracoes.component';
import { MateriaComponent } from '../materia/materia.component';
import { CadastrarMateriaComponent } from '../materia/cadastrar-materia/cadastrar-materia.component';
import { TabelaPersonalizadaComponent } from '../tabela-personalizada/tabela-personalizada.component';
import { VouchersGenericosComponent } from '../vouchers-genericos/vouchers-genericos.component';
import { VouchersAutomaticosComponent } from '../vouchers-automaticos/vouchers-automaticos.component';
import { AnexosComponent } from '../anexos/anexos.component';
import { CadastrarAnexoComponent } from '../anexos/cadastrar-anexo/cadastrar-anexo.component';
import { DescargaComponent } from '../descarga/descarga.component';
import { CadastrarDescargaComponent } from '../descarga/cadastrar-descarga/cadastrar-descarga.component';
import { PerfilAcessoComponent } from '../perfil-acesso/perfil-acesso.component';
import { CadastrarPerfilAcessoComponent } from '../perfil-acesso/cadastrar-perfil-acesso/cadastrar-perfil-acesso.component';
import { FornecedorComponent } from '../fornecedor/fornecedor.component';
import { CadastrarEstruturaLayoutComponent } from '../cadastrar-estrutura-layout/cadastrar-estrutura-layout.component';
import { FornecedorEstruturaComponent } from '../fornecedor-estrutura/fornecedor-estrutura.component';
import { PerfilEstruturaComponent } from '../perfil-estrutura/perfil-estrutura.component';
import { CadastrarPerfilEstruturaComponent } from '../perfil-estrutura/cadastrar-perfil-estrutura/cadastrar-perfil-estrutura.component';
import { ServicoEntregaComponent } from '../servico-entrega/servico-entrega.component';
import { CadastrarServicoEntregaComponent } from '../servico-entrega/cadastrar-servico-entrega/cadastrar-servico-entrega.component';
import { SeguroComponent } from '../seguro/seguro.component';
import { CadastrarSeguroComponent } from '../seguro/cadastrar-seguro/cadastrar-seguro.component';
import { ClassificacaoIntegradorComponent } from '../classificacao-integrador/classificacao-integrador.component';
import { OcorrenciaTipoComponent } from '../ocorrencia-tipo/ocorrencia-tipo.component';
import { ContatoStatusComponent } from '../contato-status/contato-status.component';
import { CadastrarContatoStatusComponent } from '../contato-status/cadastrar-contato-status/cadastrar-contato-status.component';
import { SetorComponent } from '../setor/setor.component';
import { LojaIntegracoesComponent } from '../loja-integracoes/loja-integracoes.component';
import { LojaDeProdutosConfigComponent } from '../loja-de-produtos-config/loja-de-produtos-config.component';
import { PendenciaComponent } from '../pendencia/pendencia.component';
import { CadastrarPendenciaComponent } from '../pendencia/cadastrar-pendencia/cadastrar-pendencia.component';
import { GestaoDeKitsComponent } from '../gestao-de-kits/gestao-de-kits.component';
import { EmbalagemComponent } from '../embalagem/embalagem.component';
import { CadastrarEmbalagemComponent } from '../embalagem/cadastrar-embalagem/cadastrar-embalagem.component';
import { GrupoMotivoPerdaComponent } from '../grupo-motivo-perda/grupo-motivo-perda.component';
import { CadastrarGrupoMotivoPerdaComponent } from '../grupo-motivo-perda/cadastrar-grupo-motivo-perda/cadastrar-grupo-motivo-perda.component';
import { EtapaOcorrenciaComponent } from '../etapa-ocorrencia/etapa-ocorrencia.component';
import { EtapaRastreioComponent } from '../etapa-rastreio/etapa-rastreio.component';
import { PrecificacaoUfComponent } from '../precificacao-uf/precificacao-uf.component';
import { TransferenciaItensVendedorComponent } from '../transferencia-itens-vendedor/transferencia-itens-vendedor.component';
import { CadastrarFornecedorComponent } from '../fornecedor/cadastrar-fornecedor/cadastrar-fornecedor.component';
import { CategoriaComponent } from "../categoria/categoria.component";
import { CadastrarCategoriaComponent } from "../categoria/cadastrar-categoria/cadastrar-categoria.component";
import { FeriadoComponent } from '../feriado/feriado.component';
import { CadastrarFeriadoComponent } from '../feriado/cadastrar-feriado/cadastrar-feriado.component';

// Rotas da configuração
export const ConfiguracoesRoutes: Routes = [
  {
    path: '', component: ConfiguracoesComponent,
    children: [
      {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
      },
      {
        path: 'etapas',
        component: EtapaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Etapas do Pedido',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'etapas', pai: 'configuracoes' },
        }
      },
      {
        path: 'modelos-de-email',
        component: TemplateEmailComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Modelos de E-mail',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'modelos-de-email', pai: 'configuracoes' },
        }
      },
      {
        path: 'modelos-de-email/novo',
        component: CadastrarTemplateEmailComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Modelo de E-mail',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'modelos-de-email_novo', pai: 'modelos-de-email' },
        }
      },
      {
        path: 'modelos-de-email/editar/:id',
        component: CadastrarTemplateEmailComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Modelo de E-mail',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'modelos-de-email_editar', pai: 'modelos-de-email' },
        }
      },
      {
        path: 'gestao-de-descontos',
        component: GestaoDeDescontosComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Gestão de Descontos',
          nome: 'Gestão de Descontos',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'gestao-de-descontos', pai: 'configuracoes' },
        }
      },
      {
        path: 'usuarios',
        component: FuncionarioComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Usuários',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'usuarios', pai: 'configuracoes' },
        }
      },
      {
        path: 'usuarios/novo',
        component: CadastrarFuncionarioComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Usuário',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'usuarios_novo', pai: 'usuarios' },
        }
      },
      {
        path: 'usuarios/editar/:id',
        component: CadastrarFuncionarioComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Usuário',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'usuarios_editar', pai: 'usuarios' },
        }
      },
      {
        path: 'precificacao-uf',
        component: PrecificacaoUfComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Precificação por UF',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'precificacao-uf', pai: 'configuracoes' },
        }
      },
      {
        path: 'transferencia-vendedor',
        component: TransferenciaItensVendedorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Transferência de itens de vendedor',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'transferencia-vendedor', pai: 'configuracoes' },
        }
      },
      {
        path: 'formas-de-pagamento',
        component: FormaDePagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Formas de Pagamento',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'formas-de-pagamento', pai: 'configuracoes' },
        }
      },
      {
        path: 'formas-de-pagamento/novo',
        component: CadastrarFormaDePagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Forma de Pagamento',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'formas-de-pagamento_novo', pai: 'formas-de-pagamento' },
        }
      },
      {
        path: 'formas-de-pagamento/editar/:id',
        component: CadastrarFormaDePagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Forma de Pagamento',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'formas-de-pagamento_editar', pai: 'formas-de-pagamento' },
        }
      },
      {
        path: 'condicoes-de-pagamento',
        component: CondicaoDePagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Condições de Pagamento',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'condicoes-de-pagamento', pai: 'configuracoes' },
        }
      },
      {
        path: 'condicoes-de-pagamento/novo',
        component: CadastrarCondicaoDePagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Condição de Pagamento',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'condicoes-de-pagamento_novo', pai: 'condicoes-de-pagamento' },
        }
      },
      {
        path: 'condicoes-de-pagamento/editar/:id',
        component: CadastrarCondicaoDePagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Codição de Pagamento',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'condicoes-de-pagamento_editar', pai: 'condicoes-de-pagamento' },
        }
      },
      {
        path: 'produtos',
        component: ProdutosComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Produtos',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'produtos', pai: 'configuracoes' },
        }
      },
      {
        path: 'produtos/novo',
        component: CadastrarProdutoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Produto',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'produtos_novo', pai: 'produtos' },
        }
      },
      {
        path: 'produtos/editar/:id',
        component: CadastrarProdutoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Produto',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'produtos_editar', pai: 'produtos' },
        }
      },
      {
        path: 'times',
        component: HierarquiaUsuarioComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Times',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'times', pai: 'configuracoes' },
        }
      },
      {
        path: 'premissas',
        component: PremissasComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Premissas',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'premissas', pai: 'configuracoes' },
        }
      },
      {
        path: 'combinacao-de-kits',
        component: CombinacaoKitsComponent,
        data: {
          title: 'Combinação de Kits',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'combinacao-de-kits', pai: 'configuracoes' },
        }
      },
      {
        path: 'tabela-de-fretes',
        component: TabelaDeFretesComponent,
        data: {
          title: 'Tabela de Fretes',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'tabela-de-fretes', pai: 'configuracoes' },
        }
      },
      {
        path: 'modelos-de-download',
        component: ModeloDeDownloadComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Modelos de Downloads',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'modelos-de-download', pai: 'configuracoes' },
        }
      },
      {
        path: 'modelos-de-download/novo',
        component: CadastrarModeloDeDownloadComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Modelo de Download',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'modelos-de-download_novo', pai: 'modelos-de-download' },
        }
      },
      {
        path: 'modelos-de-download/editar/:id',
        component: CadastrarModeloDeDownloadComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Modelo de Download',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'modelos-de-download_editar', pai: 'modelos-de-download' },
        }
      },
      {
        path: 'contato-status',
        component: ContatoStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Situações de Contato',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'contato-status', pai: 'configuracoes' },
        }
      },
      {
        path: 'contato-status/novo',
        component: CadastrarContatoStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Situação de Contato',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'contato-status_novo', pai: 'contato-status' },
        }
      },
      {
        path: 'contato-status/editar/:id',
        component: CadastrarContatoStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Situação de Contato',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'contato-status_editar', pai: 'contato-status' },
        }
      },
      {
        path: 'orc-status',
        component: OrcStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Situações de Orçamento',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'orc-status', pai: 'configuracoes' },
        }
      },
      {
        path: 'orc-status/novo',
        component: CadastrarOrcStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Situação de Orçamento',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'orc-status_novo', pai: 'orc-status' },
        }
      },
      {
        path: 'orc-status/editar/:id',
        component: CadastrarOrcStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Situação de Orçamento',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'orc-status_editar', pai: 'orc-status' },
        }
      },
      {
        path: 'repasse-status',
        component: OrcStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Situações de Repasse',
          tipo: 1,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'repasse-status', pai: 'configuracoes' },
        }
      },
      {
        path: 'repasse-status/novo',
        component: CadastrarOrcStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Situação de Repasse',
          tipo: 1,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'repasse-status_novo', pai: 'repasse-status' },
        }
      },
      {
        path: 'repasse-status/editar/:id',
        component: CadastrarOrcStatusComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Situação de Repasse',
          tipo: 1,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'repasse-status_editar', pai: 'repasse-status' },
        }
      },
      {
        path: 'motivo-perda',
        component: MotivoPerdaOrcComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Motivos de Perda',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'motivo-perda', pai: 'configuracoes' },
        }
      },
      {
        path: 'motivo-perda/novo',
        component: CadastrarMotivoPerdaOrcComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Motivo de Perda',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'motivo-perda_novo', pai: 'motivo-perda' },
        }
      },
      {
        path: 'motivo-perda/editar/:id',
        component: CadastrarMotivoPerdaOrcComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Motivo de Perda',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'motivo-perda_editar', pai: 'motivo-perda' },
        }
      },
      {
        path: 'tags',
        component: TagGiComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Etiquetas',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'tags', pai: 'configuracoes' },
        }
      },
      {
        path: 'tags/novo',
        component: CadastrarTagGiComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Etiqueta',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'tags_novo', pai: 'tags' },
        }
      },
      {
        path: 'tags/editar/:id',
        component: CadastrarTagGiComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Etiqueta',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'tags_editar', pai: 'tags' },
        }
      },
      {
        path: 'promocao',
        component: PromocaoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Promoções',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'promocao', pai: 'configuracoes' },
        }
      },
      {
        path: 'promocao/novo',
        component: CadastrarPromocaoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Promoção',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'promocao_novo', pai: 'promocao' },
        }
      },
      {
        path: 'promocao/editar/:id',
        component: CadastrarPromocaoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Promoção',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'promocao_editar', pai: 'promocao' },
        }
      },
      {
        path: 'materia',
        component: MateriaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Matérias e Notícias',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'materia', pai: 'configuracoes' },
        }
      },
      {
        path: 'materia/novo',
        component: CadastrarMateriaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Matéria',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'materia_novo', pai: 'materia' },
        }
      },
      {
        path: 'materia/editar/:id',
        component: CadastrarMateriaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Matéria',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'materia_editar', pai: 'materia' },
        }
      },
      {
        path: 'noticias-economia',
        component: MateriaComponent,
        canActivate: [AuthGuard],
        data: {
          thumb: true,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'materia', pai: 'configuracoes' },
        }
      },
      {
        path: 'noticias-economia/novo',
        component: CadastrarMateriaComponent,
        canActivate: [AuthGuard],
        data: {
          thumb: true,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'materia_novo', pai: 'materia' },
        }
      },
      {
        path: 'noticias-economia/editar/:id',
        component: CadastrarMateriaComponent,
        canActivate: [AuthGuard],
        data: {
          thumb: true,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'materia_editar', pai: 'materia' },
        }
      },
      {
        path: 'campanhas',
        component: PromocaoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Campanhas',
          campanha: true,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'promocao', pai: 'configuracoes' },
        }
      },
      {
        path: 'campanhas/novo',
        component: CadastrarPromocaoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Campanha',
          campanha: true,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'promocao_novo', pai: 'promocao' },
        }
      },
      {
        path: 'campanhas/editar/:id',
        component: CadastrarPromocaoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Campanha',
          campanha: true,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'promocao_editar', pai: 'promocao' },
        }
      },
      {
        path: 'tabela-personalizada',
        component: TabelaPersonalizadaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Classificações Personalizadas',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'tabela-personalizada', pai: 'configuracoes' },
        }
      },
      {
        path: 'vouchers',
        component: VouchersGenericosComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Vouchers',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'vouchers', pai: 'configuracoes' },
        }
      },
      {
        path: 'vouchers-automaticos',
        component: VouchersAutomaticosComponent,
        canActivate: [AuthGuard],
        data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'vouchers-automaticos', pai: 'configuracoes' },
        }
      },
      {
        path: 'descarga',
        component: DescargaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Descargas',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'descarga', pai: 'configuracoes' },
        }
      },
      {
        path: 'descarga/nova',
        component: CadastrarDescargaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Descarga',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'descarga_novo', pai: 'descarga' },
        }
      },
      {
        path: 'descarga/editar/:id',
        component: CadastrarDescargaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Descarga',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'descarga_editar', pai: 'descarga' },
        }
      },
      {
        path: 'permissoes-de-acesso',
        component: PerfilAcessoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Permissões de Acesso',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'permissoes-de-acesso', pai: 'configuracoes' },
        }
      },
      {
        path: 'permissoes-de-acesso/novo',
        component: CadastrarPerfilAcessoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Permissão de Acesso',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'permissoes-de-acesso_novo', pai: 'permissoes-de-acesso' },
        }
      },
      {
        path: 'permissoes-de-acesso/editar/:id',
        component: CadastrarPerfilAcessoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Permissão de Acesso',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'permissoes-de-acesso_editar', pai: 'permissoes-de-acesso' },
        }
      },
      {
        path: 'centros-de-distribuicao',
        component: FornecedorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Centros de Distribuição',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'centros-de-distribuicao', pai: 'configuracoes' },
        }
      },
      {
        path: 'centros-de-distribuicao/novo',
        component: CadastrarFornecedorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Centro de Distribuição',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'centros-de-distribuicao_novo', pai: 'centros-de-distribuicao' },
        }
      },
      {
        path: 'centros-de-distribuicao/editar/:id',
        component: CadastrarFornecedorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Centro de Distribuição',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'centros-de-distribuicao_editar', pai: 'centros-de-distribuicao' },
        }
      },
      {
        path: 'fornecedores',
        component: FornecedorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fornecedores',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fornecedores', pai: 'configuracoes' },
        }
      },
      {
        path: 'fornecedores/novo',
        component: CadastrarFornecedorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Fornecedor',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fornecedores_novo', pai: 'fornecedores' },
        }
      },
      {
        path: 'fornecedores/editar/:id',
        component: CadastrarFornecedorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Fornecedor',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fornecedores_editar', pai: 'fornecedores' },
        }
      },
      {
        path: 'anexos',
        component: AnexosComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Anexos',
          nome: 'Anexos',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'anexos', pai: 'configuracoes' },
        }
      },
      {
        path: 'anexos/novo',
        component: CadastrarAnexoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Anexo',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'anexos_novo', pai: 'anexos' },
        }
      },
      {
        path: 'anexos/editar/:id',
        component: CadastrarAnexoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Anexo',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'anexos_editar', pai: 'anexos' },
        }
      },
      {
        path: 'estruturas',
        component: CadastrarEstruturaLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Estruturas',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'estruturas', pai: 'configuracoes' },
        }
      },
      {
        path: 'fornecedores-estrutura',
        component: FornecedorEstruturaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fornecedores de Estruturas',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fornecedores-estrutura', pai: 'configuracoes' },
        }
      },
      {
        path: 'perfil-estrutura',
        component: PerfilEstruturaComponent,
        canActivate: [AuthGuard],
        data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'perfil-estrutura', pai: 'configuracoes' },
        }
      },
      {
        path: 'perfil-estrutura/novo',
        component: CadastrarPerfilEstruturaComponent,
        canActivate: [AuthGuard],
        data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'perfil-estrutura_novo', pai: 'perfil-estrutura' },
        }
      },
      {
        path: 'perfil-estrutura/editar/:id',
        component: CadastrarPerfilEstruturaComponent,
        canActivate: [AuthGuard],
        data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'perfil-estrutura_editar', pai: 'perfil-estrutura' },
        }
      },
      {
        path: 'servico-entrega',
        component: ServicoEntregaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Serviços de Entrega',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'servico-entrega', pai: 'configuracoes' },
        }
      },
      {
        path: 'servico-entrega/novo',
        component: CadastrarServicoEntregaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Serviço de Entrega',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'servico-entrega_novo', pai: 'servico-entrega' },
        }
      },
      {
        path: 'servico-entrega/editar/:id',
        component: CadastrarServicoEntregaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Serviço de Entrega',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'servico-entrega_editar', pai: 'servico-entrega' },
        }
      },
      {
        path: 'seguro',
        component: SeguroComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Seguros',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'seguro', pai: 'configuracoes' },
        }
      },
      {
        path: 'seguro/novo',
        component: CadastrarSeguroComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Seguro',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'seguro_novo', pai: 'seguro' },
        }
      },
      {
        path: 'seguro/editar/:id',
        component: CadastrarSeguroComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Seguro',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'seguro_editar', pai: 'seguro' },
        }
      },
      {
        path: 'classificacao-integrador',
        component: ClassificacaoIntegradorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Classificações de Integradores',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'classificacao-integrador', pai: 'configuracoes' },
        }
      },
      {
        path: 'ocorrencia-tipo',
        component: OcorrenciaTipoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Tipos de Ocorrências',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'ocorrencia-tipo', pai: 'configuracoes' },
        }
      },
      {
        path: 'gestao-de-kits',
        component: GestaoDeKitsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Gestão de Kits',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'gestao-de-kits', pai: 'configuracoes' },
        }
      },
      {
        path: 'setores',
        component: SetorComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Setores',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'setores', pai: 'configuracoes' },
        }
      },
      {
        path: 'loja-integracoes',
        component: LojaIntegracoesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Loja de Integrações',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'loja-integracoes', pai: 'configuracoes' },
        }
      },
      {
        path: 'loja-produtos',
        component: LojaDeProdutosConfigComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Loja de Produtos',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'loja-produtos', pai: 'configuracoes' },
        }
      },
      {
        path: 'configuracoes-crm',
        loadChildren: () => import('../crm/configuracoes-crm/configuracoes-crm.module').then(m => m.ConfiguracoesCrmModule),
      },
      {
        path: 'pendencias',
        component: PendenciaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Pendências',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'pendencias', pai: 'configuracoes' },
        }
      },
      {
        path: 'pendencias/novo',
        component: CadastrarPendenciaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Pendência',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'pendencias_novo', pai: 'configuracoes' },
        }
      },
      {
        path: 'pendencias/editar/:id',
        component: CadastrarPendenciaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Pendência',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'pendencias_editar', pai: 'configuracoes' },
        }
      },
      {
        path: 'embalagem',
        component: EmbalagemComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Embalagem',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'embalagem', pai: 'configuracoes' },
        }
      },
      {
        path: 'embalagem/novo',
        component: CadastrarEmbalagemComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Embalagem',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'embalagem_novo', pai: 'embalagem' },
        }
      },
      {
        path: 'embalagem/editar/:id',
        component: CadastrarEmbalagemComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Embalagem',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'embalagem_editar', pai: 'embalagem' },
        }
      },
      {
        path: 'categoria',
        component: CategoriaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Categoria',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'categoria', pai: 'configuracoes' },
        }
      },
      {
        path: 'categoria/novo',
        component: CadastrarCategoriaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Categoria',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'categoria_novo', pai: 'categoria' },
        }
      },
      {
        path: 'categoria/editar/:id',
        component: CadastrarCategoriaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Categoria',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'categoria_editar', pai: 'categoria' },
        }
      },
      {
        path: 'grupo_motivo_perda',
        component: GrupoMotivoPerdaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Grupo Motivo Perda',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'grupo_motivo_perda', pai: 'configuracoes' },
        }
      },
      {
        path: 'grupo_motivo_perda/novo',
        component: CadastrarGrupoMotivoPerdaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Grupo Motivo Perda - Novo',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'grupo_motivo_perda_novo', pai: 'grupo_motivo_perda' },
        }
      },
      {
        path: 'grupo_motivo_perda/editar/:id',
        component: CadastrarGrupoMotivoPerdaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Grupo Motivo Perda - Editar',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'grupo_motivo_perda_editar', pai: 'grupo_motivo_perda' },
        }
      },

      {
        path: 'feriado',
        component: FeriadoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Feriados',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'feriado', pai: 'configuracoes' },
        }
      },
      {
        path: 'feriado/novo',
        component: CadastrarFeriadoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Feriado',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'feriado_novo', pai: 'feriado' },
        }
      },
      {
        path: 'feriado/editar/:id',
        component: CadastrarFeriadoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Feriado',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'feriado_editar', pai: 'feriado' },
        }
      },
      {
        path: 'geral',
        loadChildren: () => import('../core/config-config.module').then(m => m.ConfigConfigModule),
      },
      {
        path: 'config-financiamento',
        loadChildren: () => import('../financiamento/financiamento-config.module').then(m => m.FinanciamentoConfigModule),
      },
      {
        path: 'config-vendas',
        loadChildren: () => import('../orcamento/orcamento.config.module').then(m => m.OrcamentoConfigModule),
      },
      {
        path: 'config-notificacao',
        loadChildren: () => import('../notificacao/notificacao-config.module').then(m => m.NotificacaoConfigModule),
      },
      {
        path: 'config-loja-gi',
        loadChildren: () => import('../loja-gi/gi-loja-config.module').then(m => m.GiLojaConfigModule),
      },
      {
        path: 'workflows',
        loadChildren: () => import('../workflow/workflow-config.module').then(m => m.WorkflowConfigModule),
      },
      {
        path: 'etapa-ocorrencia',
        component: EtapaOcorrenciaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Etapa da Ocorrência',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'etapa-ocorrencia', pai: 'configuracoes' },
        }
      },
      {
        path: 'etapa-rastreio',
        component: EtapaRastreioComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Etapas do Rastreio',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'etapa-rastreio', pai: 'configuracoes' },
        }
      },
    ]
  }
];
